module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/headphones-3bd791fc538ca4ef2a354ef9d82ce38c.svg";